import React from 'react';
import { HelpCircle, Info, CheckCircle, AlertTriangle, ExternalLink } from 'lucide-react';

const HelpInfoSidebar = () => {
  const tips = [
    {
      icon: <CheckCircle className="w-4 h-4 text-green-500" />,
      title: 'Равномерное распределение нагрузки',
      description: 'Старайтесь равномерно распределить нагрузку в течение недели. Сложные предметы лучше планировать на вторник и среду.'
    },
    {
      icon: <Info className="w-4 h-4 text-blue-500" />,
      title: 'Учитывайте "Окна" в расписании',
      description: 'Избегайте длительных "окон" в расписании – перерывов, когда учащиеся или преподаватели вынуждены ждать следующего занятия.'
    },
    {
      icon: <AlertTriangle className="w-4 h-4 text-yellow-500" />,
      title: 'Нормы СанПиН',
      description: 'В российских школах необходимо соблюдать нормы СанПиН по количеству уроков в день и неделю для разных классов.'
    },
    {
      icon: <Info className="w-4 h-4 text-blue-500" />,
      title: 'Чередование предметов',
      description: 'Чередуйте предметы разной сложности и направленности (естественнонаучные, гуманитарные, творческие) в течение дня.'
    },
    {
      icon: <CheckCircle className="w-4 h-4 text-green-500" />,
      title: 'Сбалансированность по дням',
      description: 'Распределяйте количество занятий равномерно по дням недели, избегая перегрузки в отдельные дни.'
    }
  ];

  // Ссылки на полезные ресурсы
  const resources = [
    {
      title: 'СанПиН 2.4.2.2821-10',
      description: 'Санитарно-эпидемиологические требования к условиям и организации обучения в общеобразовательных учреждениях',
      url: 'http://docs.cntd.ru/document/902256369'
    },
    {
      title: 'ФГОС общего образования',
      description: 'Федеральные государственные образовательные стандарты общего образования',
      url: 'https://fgos.ru/'
    },
    {
      title: 'Шкала трудности предметов',
      description: 'Официальная шкала трудности учебных предметов по И.Г. Сивкову для российских школ',
      url: 'http://www.consultant.ru/document/cons_doc_LAW_325763/'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по составлению расписания
      </h3>

      <div className="space-y-3 mb-6">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <div className="mt-0.5 flex-shrink-0">
              {tip.icon}
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-3 flex items-center">
        <Info className="w-4 h-4 mr-1 text-indigo-500" />
        Полезные ресурсы
      </h4>

      <div className="space-y-3">
        {resources.map((resource, index) => (
          <a 
            key={index}
            href={resource.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block p-3 bg-indigo-50 dark:bg-indigo-900/20 rounded-lg border border-indigo-100 dark:border-indigo-800 hover:bg-indigo-100 dark:hover:bg-indigo-900/40 transition-colors"
          >
            <div className="flex justify-between items-center">
              <h5 className="text-sm font-medium text-indigo-700 dark:text-indigo-300">
                {resource.title}
              </h5>
              <ExternalLink className="w-3 h-3 text-indigo-500 dark:text-indigo-400" />
            </div>
            <p className="text-xs text-indigo-600 dark:text-indigo-400 mt-1">
              {resource.description}
            </p>
          </a>
        ))}
      </div>

      <div className="mt-6 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-100 dark:border-yellow-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <AlertTriangle className="w-5 h-5 text-yellow-500 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-yellow-700 dark:text-yellow-300 mb-1">
              Российская специфика
            </h4>
            <p className="text-xs text-yellow-600 dark:text-yellow-400">
              При составлении школьного расписания в России учитывайте, что согласно нормам, для учащихся 1 классов 
              максимальная недельная нагрузка составляет 21 час, для 2-4 классов - 23 часа, для 5-6 классов - 
              32 часа, для 7 класса - 35 часов, для 8-9 классов - 36 часов, для 10-11 классов - 37 часов.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpInfoSidebar;